import AuthAPI from './authInstance'

const getAll = async (params = {}) => {
  const response = await AuthAPI.get(`/admin/course/list`, { params })
  return response.data
}

const getAllByClass = async (data) => {
  const response = await AuthAPI.get(`/admin/course/list/${data}`)
  return response.data
}

const getAllByClassSubj = async (data) => {
  const response = await AuthAPI.get(`/admin/course/list-subj/${data.learner_class_id}/${data.subject_id}`)
  return response.data
}

const getOne = async (data) => {
  const response = await AuthAPI.get(`/admin/course/show/${data}`)
  return response.data
}

const createCourse = async (data) => {
  const response = await AuthAPI.post(`/admin/course/create`, data)
  return response.data
}

const editCourse = async (data) => {
  const response = await AuthAPI.post(`/admin/course/update`, data)
  return response.data
}

const deleteOne = async (data) => {
  const response = await AuthAPI.delete(`/admin/course/delete/${data}`)
  return response.data
}

const addCourseContent = async (data) => {
  const response = await AuthAPI.post(`/admin/course/add-content`, data)
  return response.data
}

export const courseService = {
  getAll,
  getAllByClass,
  getAllByClassSubj,
  getOne,
  createCourse,
  editCourse,
  deleteOne,
  addCourseContent,
}
